export enum CouponType {
  DISCOUNT = 'DISCOUNT',
  FREE_PLAN = 'FREE_PLAN',
}

export enum CouponAppliesTo  {
  customer = 'customer',
  subscription = 'subscription',
}
